// @ts-nocheck
import { faEllipsisH, faPlus, faBolt, faChartLine } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import { currencyFormat } from "helpers/utils";
import { Dropdown, Badge } from "react-bootstrap";
import DealCardAICompact from "components/cards/DealCardAICompact";
import { Draggable } from "react-beautiful-dnd";
import { dealsAtom } from "jotai/LeadsJotaiInstance";
import { useAtom } from "jotai";
import { useState } from "react";
import axiosInstance from "helpers/api";
import toast from "react-hot-toast";
import ConfirmDeleteModal from "../common-components/ConfirmDeleteModal";

const DealColumnAICompact = ({ column, handleOpenAddModal }: any) => {
  const [deals, setDeals] = useAtom(dealsAtom);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const handleShowDeleteModal = (id: any) => {
    setShowDeleteModal(true);
    setSelectedLeadId(id);
  };

  const handleDeleteStage = async (id: any) => {
    try {
      const response = await axiosInstance.delete(`/deals/deal-stages/${id}`);
      toast.success(response.data.message);
      const filterDeals = deals.filter((item: any) => item.id !== id);
      setDeals(filterDeals);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  // Calculate metrics
  const totalValue = column.deals?.reduce((sum: number, deal: any) => 
    sum + (parseFloat(deal.deal_price) || 0), 0
  ) || 0;
  
  // AI-powered stage health (mock - would come from backend)
  const stageHealth = column.deals?.length > 5 ? 'warning' : column.deals?.length > 0 ? 'healthy' : 'empty';
  const healthColor = stageHealth === 'healthy' ? '#10b981' : stageHealth === 'warning' ? '#f59e0b' : '#9ca3af';

  return (
    <div 
      className="deals-column-ai-compact"
      style={{
        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.9) 100%)',
        borderRadius: '12px',
        border: '1px solid rgba(0, 212, 255, 0.2)',
        backdropFilter: 'blur(15px)',
        padding: '14px',
        width: '340px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 250px)',
        minHeight: '500px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.03)',
        transition: 'all 0.3s ease'
      }}
    >
      {/* AI-Enhanced Compact Column Header */}
      <div 
        className="column-header"
        style={{
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
          borderRadius: '10px',
          padding: '12px',
          marginBottom: '12px',
          border: '1px solid rgba(0, 212, 255, 0.15)',
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backdropFilter: 'blur(10px)'
        }}
      >
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center">
            {/* AI Status Indicator */}
            <div 
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: healthColor,
                marginRight: '8px',
                boxShadow: `0 0 8px ${healthColor}50`,
                animation: stageHealth === 'warning' ? 'pulse 2s infinite' : 'none'
              }}
            />
            
            <h6 
              className="mb-0"
              style={{ 
                fontSize: '15px',
                fontWeight: 600,
                color: '#1f2937',
                textShadow: '0 0 10px rgba(0, 212, 255, 0.1)'
              }}
            >
              {column.deal_stage_name}
            </h6>
            
            {/* Deal Count Badge */}
            <Badge 
              style={{
                marginLeft: '8px',
                fontSize: '11px',
                padding: '3px 7px',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.2) 0%, rgba(14, 165, 233, 0.2) 100%)',
                border: '1px solid rgba(0, 212, 255, 0.3)',
                color: '#0ea5e9',
                fontWeight: 600
              }}
            >
              {column.deals?.length || 0}
            </Badge>
          </div>
          
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              className="p-0"
              style={{ 
                fontSize: '14px',
                color: '#9ca3af',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#00d4ff'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}
            >
              <FontAwesomeIcon icon={faEllipsisH} />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)' }}>
              <Dropdown.Item 
                onClick={() => handleOpenAddModal(column.id)}
                style={{ fontSize: '13px' }}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" style={{ color: '#00d4ff' }} />
                Add Deal
              </Dropdown.Item>
              {column.isCustom && (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    className="text-danger"
                    onClick={() => handleShowDeleteModal(column.id)}
                    style={{ fontSize: '13px' }}
                  >
                    Delete Stage
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        
        {/* AI Metrics Bar */}
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-1">
            <FontAwesomeIcon 
              icon={faChartLine} 
              style={{ 
                fontSize: '10px',
                color: '#00d4ff',
                filter: 'drop-shadow(0 0 3px rgba(0, 212, 255, 0.5))'
              }}
            />
            <span style={{ 
              fontSize: '13px',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              ${(totalValue / 1000).toFixed(0)}k
            </span>
          </div>
          
          {/* AI Insight */}
          {column.deals?.length > 3 && (
            <span style={{ 
              fontSize: '10px',
              color: '#64748b',
              fontStyle: 'italic'
            }}>
              <FontAwesomeIcon icon={faBolt} style={{ marginRight: '3px', color: '#00d4ff' }} />
              {column.deals.length > 5 ? 'High volume' : 'Active stage'}
            </span>
          )}
        </div>
      </div>

      {/* Scrollable Deal List with AI Glow */}
      <div 
        className="deals-list"
        style={{
          overflowY: 'auto',
          flex: 1,
          paddingRight: '4px',
          position: 'relative'
        }}
      >
        {/* AI Gradient Overlay */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '30px',
            background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, transparent 100%)',
            pointerEvents: 'none',
            zIndex: 1
          }}
        />
        
        {column.deals?.map((deal: any, index: number) => (
          <Draggable key={deal.id} draggableId={deal.id} index={index}>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <DealCardAICompact deal={deal} />
              </div>
            )}
          </Draggable>
        ))}
        
        {/* Empty State with AI Assistant */}
        {(!column.deals || column.deals.length === 0) && (
          <div 
            className="text-center py-5"
            style={{
              background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.05) 0%, rgba(14, 165, 233, 0.05) 100%)',
              borderRadius: '10px',
              border: '1px dashed rgba(0, 212, 255, 0.2)',
              margin: '8px'
            }}
          >
            <FontAwesomeIcon 
              icon={faBolt} 
              style={{ 
                fontSize: '24px',
                color: '#00d4ff',
                marginBottom: '12px',
                filter: 'drop-shadow(0 0 10px rgba(0, 212, 255, 0.5))'
              }}
              className="pulse-animation"
            />
            <p style={{ 
              color: '#64748b',
              fontSize: '13px',
              marginBottom: '8px'
            }}>
              AI Assistant ready to help
            </p>
            <Button
              size="sm"
              onClick={() => handleOpenAddModal(column.id)}
              style={{ 
                fontSize: '12px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                borderRadius: '8px',
                padding: '6px 16px',
                boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
              }}
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              Add first deal
            </Button>
          </div>
        )}
      </div>

      {/* AI-Enhanced Add Deal Button */}
      <div 
        className="mt-3 pt-3" 
        style={{ 
          borderTop: '1px solid rgba(0, 212, 255, 0.1)'
        }}
      >
        <Button
          variant="link"
          className="w-100 text-center"
          onClick={() => handleOpenAddModal(column.id)}
          style={{ 
            fontSize: '12px',
            color: '#64748b',
            textDecoration: 'none',
            padding: '8px',
            borderRadius: '8px',
            background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.05) 0%, transparent 100%)',
            border: '1px solid transparent',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(14, 165, 233, 0.1) 100%)';
            e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.2)';
            e.currentTarget.style.color = '#00d4ff';
            e.currentTarget.style.textShadow = '0 0 8px rgba(0, 212, 255, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(0, 212, 255, 0.05) 0%, transparent 100%)';
            e.currentTarget.style.borderColor = 'transparent';
            e.currentTarget.style.color = '#64748b';
            e.currentTarget.style.textShadow = 'none';
          }}
        >
          <FontAwesomeIcon 
            icon={faPlus} 
            className="me-1"
            style={{ 
              fontSize: '10px',
              filter: 'drop-shadow(0 0 3px rgba(0, 212, 255, 0.3))'
            }}
          />
          Add Deal with AI
        </Button>
      </div>

      {/* Custom Scrollbar Styles */}
      <style>{`
        .deals-list::-webkit-scrollbar {
          width: 6px;
        }
        
        .deals-list::-webkit-scrollbar-track {
          background: rgba(0, 212, 255, 0.05);
          border-radius: 3px;
        }
        
        .deals-list::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, rgba(0, 212, 255, 0.3) 0%, rgba(14, 165, 233, 0.3) 100%);
          border-radius: 3px;
        }
        
        .deals-list::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(135deg, rgba(0, 212, 255, 0.5) 0%, rgba(14, 165, 233, 0.5) 100%);
        }
        
        @keyframes pulse {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
        
        .pulse-animation {
          animation: pulse 2s infinite;
        }
      `}</style>

      <ConfirmDeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => handleDeleteStage(selectedLeadId)}
        message="Are you sure you want to delete this stage?"
      />
    </div>
  );
};

export default DealColumnAICompact;